// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/legacy/" + (chunkId === 460 ? "sharing" : chunkId) + "." + {"128":"295d58a9","460":"9abffeab"}[chunkId] + ".js";
};